import Layout from "../../components/layout";

export default function Privacy() {
  return (
      <Layout>

        <div class="privacy-wrapper">

    <section class="hero">
      <div class="container">
        <h1 class="title">Privacy Policy</h1>
        <p class="subtitle">We take your privacy seriously — especially when it comes to technology.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">1. What We Collect</h2>
        <p>We collect basic information like your name, email, phone number, and project details when you reach out for AV consultations, rentals, or installations.</p>
        <p>We also collect technical data (browser type, device, location) when you visit our site, for analytics and service improvement.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">2. How We Use Your Data</h2>
        <p>Your information helps us deliver AV solutions that fit your exact needs — from live events to commercial installations. We use it to respond to inquiries, plan logistics, and communicate clearly.</p>
        <p>We also use anonymous traffic data to improve our site’s performance and presentation.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">3. AV Equipment Monitoring & Security</h2>
        <p>Some of our AV systems may include usage tracking or remote diagnostics. This is used solely for maintaining performance, reducing downtime, and ensuring your experience remains seamless.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">4. Third-Party Services</h2>
        <p>We may use tools like Google Analytics or embedded media players. These providers may collect anonymized data in accordance with their own privacy policies.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">5. Your Rights</h2>
        <p>You have the right to request, correct, or delete your personal data. If you’ve submitted a project or filled out a form, you can contact us at any time to review that information.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">6. Contact</h2>
        <p>For questions about this privacy policy or your data, email us at <a href="mailto:privacy@proslv.com.ph">privacy@proslv.com</a>.</p>
      </div>
    </section>

  </div>

      </Layout>
  );
}
